<!-- src/app/pages/qr-compilations/qr-compilations.component.html -->
<app-quiz-layout
  title="Questionario Clima Aziendale"
  variant="narrow"
  [centered]="true">

  <!-- LOADING -->
  <div class="qr-waiter" *ngIf="isLoading; else content">
    <div class="qr-waiter__text">Sto verificando il link…</div>
    <div class="qr-loader" aria-label="Caricamento" role="status">
      <span class="qr-loader__dot"></span>
      <span class="qr-loader__dot"></span>
      <span class="qr-loader__dot"></span>
      <span class="qr-loader__dot"></span>
    </div>
  </div>

  <!-- CONTENT -->
  <ng-template #content>
    <!-- NORMAL (NOT EXPIRED) -->
    <section class="qr-card" *ngIf="!isExpiredClima; else expired">
      <h1 class="qr-card__reparto">{{ repartoName || 'Reparto non disponibile' }}</h1>

      <ng-container *ngIf="!slotFull">
        <p class="qr-card__desc">
          È possibile compilare il questionario una sola volta.
        </p>

        <div class="qr-meta" *ngIf="dueDate">
          <span class="qr-meta__label">Scadenza</span>
          <span class="qr-meta__value">{{ dueDate }}</span>
        </div>

        <button
          nz-button
          nzSize="large"
          nzType="primary"
          class="qr-cta"
          nz-popconfirm
          [nzPopconfirmTitle]="'Confermi di far parte del reparto (' + (repartoName || '') + ') e di non aver già compilato il questionario?'"
          nzPopconfirmPlacement="top"
          nzOkText="Conferma"
          nzCancelText="Annulla"
          (nzOnConfirm)="useLicenza()"
          [nzLoading]="isStarting">
          Inizia
        </button>
      </ng-container>

      <div *ngIf="slotFull" class="qr-meta qr-meta--alert qr-shake">
        <span class="qr-meta__label">Slot Terminati</span>
        <span class="qr-meta__value">{{ slotReparto }}</span>
      </div>
    </section>

    <!-- EXPIRED -->
    <ng-template #expired>
      <section class="qr-card">
        <h1 class="qr-card__reparto">{{ repartoName || 'Reparto non disponibile' }}</h1>
        <p class="qr-card__desc">
          Il periodo di compilazione del questionario sul clima aziendale si è concluso.
        </p>

        <div class="qr-meta" *ngIf="scadenza && !slotFull">
          <span class="qr-meta__label">Scadenza</span>
          <span class="qr-meta__value">
            {{ scadenza.seconds ? (scadenza.seconds * 1000 | date: 'dd/MM/yyyy')
            : (scadenza | date: 'dd/MM/yyyy') }}
          </span>
        </div>
      </section>
    </ng-template>
  </ng-template>
</app-quiz-layout>
